// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1ZWgO","content":"content___2mUdx","newModel":"newModel___2hQmM","header":"header___WS6Fc","saveButton":"saveButton___3y859"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RequestView/RequestView.module.css
// module id = 370
// module chunks = 0